import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="range-slider"
export default class extends Controller {
  static targets = ["slider", "currentPrice"]
  static values = { locale: String, currency: String }

  connect() {
    this.updatePrice()
  }

  updatePrice() {
    const value = this.sliderTarget.value
    const formattedValue = this.formatCurrency(value)
    this.currentPriceTarget.textContent = formattedValue
  }

  formatCurrency(value) {
    const number = parseFloat(value)

    // Format the currency using the provided locale and currency
    return new Intl.NumberFormat(this.localeValue, {
      style: 'currency',
      currency: this.currencyValue,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(number)
  }
}
